import { defineComponent as _defineComponent } from 'vue'
import CardExportFooter from '~/components/export/CardFooter.vue'
import CardExportHeader from '~/components/export/CardHeader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardFlowing',
  props: {
  companyName: {
    type: String,
    required: true,
  },
  exportedAt: {
    type: [Date, String, Number],
    required: true,
  },
},
  setup(__props) {



return { __sfc: true,CardExportFooter, CardExportHeader }
}

})